import React from 'react';
import { Line, Bar, Pie, Doughnut } from 'react-chartjs-2';
import dayjs from 'dayjs';
import 'chart.js/auto';
import 'chartjs-adapter-dayjs-4';

export default function ChartViewer({ resultSet, pivotConfig, chartType, height='750px' }) {

  const chartData = resultSet.chartPivot(pivotConfig).map((row) => ({
    x: row.x,
    y: row.y,
  }));

  const datasets = resultSet.series(pivotConfig).map((item) => ({
    fill: chartType === 'area',
    label: item.title,
    data: chartData, // Use the array of { x, y } points
    borderColor: '#4f46e5',
    backgroundColor: 'rgba(79, 70, 229, 0.2)',
    pointHitRadius: 10,
    pointRadius: 5,
  }));

  // No need for labels since data points contain x values
  const data = {
    datasets: datasets,
  };

  const ChartElement = {
    area: Line,
    bar: Bar,
    doughnut: Doughnut,
    line: Line,
    pie: Pie,
  }[chartType];

  // Configure chart options
  const options = {
    responsive: true,
    maintainAspectRatio: false, // Disable default aspect ratio
    plugins: {
      tooltip: {
        callbacks: {
          title: (tooltipItems) => {
            const date = tooltipItems[0].raw.x;
            return dayjs(date).format('MMM D, YYYY');
          },
        },
        mode: 'index',
        intersect: false,
      },
    },
    hover: {
      mode: 'nearest',
      intersect: true,
    },
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'day',
          stepSize: 1,
          displayFormats: {
            day: 'MMM D, YYYY',
          },
        },
        ticks: {
          maxTicksLimit: 10,
          source: 'auto',
          autoSkip: true,
        },
      },
    },
  };

  // Set a container for the chart with a fixed height
  const chartContainerStyle = {
    height: height,
  };

  return (
    <div style={chartContainerStyle}>
      <ChartElement data={data} options={options} />
    </div>
  );
}
